import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import noTranslations from './locales/no';
import enTranslations from './locales/en';

export const LANGUAGE_STORAGE_KEY = 'mundu-language';

export const SUPPORTED_LANGUAGES: Record<string, { label: string }> = {
    no: { label: 'Norsk' },
    en: { label: 'English' },
};

const getInitialLanguage = () => {
    if (typeof window === 'undefined') {
        return 'no';
    }
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES[stored]) {
        return stored;
    }
    const browserLanguage =
        typeof navigator !== 'undefined' ? navigator.language : undefined;
    return browserLanguage?.startsWith('en') ? 'en' : 'no';
};

const resources = {
    no: { translation: noTranslations },
    en: { translation: enTranslations },
};

i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'no',
    interpolation: {
        escapeValue: false,
    },
    returnEmptyString: false,
});

i18n.on('languageChanged', lng => {
    if (typeof window === 'undefined') {
        return;
    }
    if (SUPPORTED_LANGUAGES[lng]) {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    }
});

export default i18n;
